import MockAdapter from "axios-mock-adapter";
// mock testing user accounts
const users = [
    {
        name: "Name",
        surname: "Surname",
        username: "admin@admin.com",
        password: "admin",
        api_token: "mgfi5juf74j",
    },
    {
        name: "Name",
        surname: "Surname 2",
        username: "admin2@admin.com",
        password: "admin",
        api_token: "fgj8fjdfk43",
    },
];
class MockService {
    static init(app) {
        // this sets the mock adapter on the default instance
        const mock = new MockAdapter(app.axios);
        // mock login request
        mock
            //.onPost(`${import.meta.env.VITE_API_URL}/login/Authenticate`).reply((data) => {
            //    const params = JSON.parse(data.data).params;
            //    const found = users.find((user) => {
            //        return (
            //            params.username === user.username &&
            //            params.password === user.password
            //        );
            //    });
            //    
            //    if (found) {
            //        return [200, found];
            //    }
            //    return [404, { errors: ["The login detail is incorrect"] }];
            //})
            .onPost("/registration").reply((data) => {
            const newUser = JSON.parse(data.data);
            if (newUser.name &&
                newUser.surname &&
                newUser.email &&
                newUser.password) {
                const found = users.find((user) => {
                    return newUser.email === user.username;
                });
                if (!found) {
                    newUser.api_token = Math.random().toString(36).substr(2, 9);
                    users.push(newUser);
                    return [200, newUser];
                }
                return [409, { errors: ["User with this email already exists."] }];
            }
            return [400, { errors: ["Please fill all needed fields to continue."] }];
        }).onPost("/forgot_password").reply((data) => {
            const { email } = JSON.parse(data.data);
            if (email) {
                const user = users.find((x) => x.username.toLowerCase() === email.toLowerCase());
                if (user) {
                    return [200, user];
                }
                return [404, { errors: ["Users with this email is not found."] }];
            }
            return [400, { errors: ["Please fill all needed fields to continue."] }];
        }).onGet("/verify_token").reply((data) => {
            const token = data.headers.Authorization.replace("Token ", "");
            if (token !== "undefined") {
                const found = users.find((user) => {
                    return token === user.api_token;
                });
                return [200, found];
            }
            return [401, { errors: ["Invalid authentication"] }];
        }).onAny().passThrough();
    }
}
export default MockService;
//# sourceMappingURL=MockService.js.map